module.exports = __webpack_public_path__ + "img/Act-to-adapt@2x.7dd2ce5b.jpg";